import { lazy } from 'react';

const Merchant = lazy(() => import('./MerchantPage'));

const MerchantSignInConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'merchant/sign-in',
      element: <Merchant />,
    },
  ],
};

export default MerchantSignInConfig;
